import FormattedMessage from 'I18n/components/FormattedMessage';
import { CLONE_WARNING_MESSAGE } from 'asset-actions-lib-forms/constants/formCloning';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  NOT_CLONE_WORKFLOWS_AND_GDPR,
  NOT_CLONE_WORKFLOWS,
  NOT_CLONE_GDPR
} = CLONE_WARNING_MESSAGE;
const WARNING_MESSAGES = {
  clone: {
    [NOT_CLONE_WORKFLOWS_AND_GDPR]: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "assetActionsLibForms.modals.cloneDialog.warning.NOT_CLONE_WORKFLOWS_AND_GDPR"
    }),
    [NOT_CLONE_WORKFLOWS]: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "assetActionsLibForms.modals.cloneDialog.warning.NOT_CLONE_WORKFLOWS"
    }),
    [NOT_CLONE_GDPR]: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "assetActionsLibForms.modals.cloneDialog.warning.NOT_CLONE_GDPR"
    })
  },
  copy: {
    [NOT_CLONE_WORKFLOWS_AND_GDPR]: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "assetActionsLibForms.modals.cloneDialog.warning.NOT_CLONE_WORKFLOWS_AND_GDPR"
    }),
    [NOT_CLONE_WORKFLOWS]: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "assetActionsLibForms.modals.cloneDialog.warning.NOT_CLONE_WORKFLOWS"
    }),
    [NOT_CLONE_GDPR]: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "assetActionsLibForms.modals.cloneDialog.warning.NOT_CLONE_GDPR"
    })
  }
};

/**
 * Taken from https://git.hubteam.com/HubSpot/submissions-ui/blob/3765824bb210d7f8fb69ba9adc433fa1eab89a17/submissions-ui/static/js/components/formCloning/FormCloningWarningMessage.js
 */
export default function FormCloningWarningMessage({
  warning,
  isExternalEditor
}) {
  if (!warning) {
    return null;
  }
  const type = isExternalEditor ? 'copy' : 'clone';
  const message = WARNING_MESSAGES[type][warning];
  return message ? /*#__PURE__*/_jsx("p", {
    children: message
  }) : null;
}